import { Button, Spinner } from "@ui";
import { useSharedChat } from "@agentic_conversation/contexts/shared-chat-context";
import { useRetryConversation } from "@agentic_conversation/api/conversation";
import { AlertTriangle, RefreshCw, XCircle } from "lucide-react";
import { useState } from "react";

export function InterruptedFooter() {
  const { throttle, conversationId } = useSharedChat();
  const retryMutation = useRetryConversation(conversationId);
  const [tokenLimitExceeded, setTokenLimitExceeded] = useState(false);

  const handleRetry = () => {
    retryMutation.mutate(undefined, {
      onError: (error: Error & { response?: { data?: { error?: string } } }) => {
        if (error.response?.data?.error === "token_limit_exceeded") {
          setTokenLimitExceeded(true);
        }
      },
    });
  };

  // Token limit exceeded - no retry possible
  if (tokenLimitExceeded) {
    return (
      <div className="flex items-center gap-2 text-sm text-red-600">
        <XCircle className="w-4 h-4" />
        <span>Conversation terminée (limite de tokens atteinte)</span>
      </div>
    );
  }

  // Interrupted - can retry when throttle clears
  return (
    <div className="flex items-center gap-2">
      <AlertTriangle className="w-4 h-4 text-amber-500" />
      <span className="text-sm text-amber-700">Interrompu</span>
      {!throttle && (
        <Button
          variant="white"
          size="sm"
          onClick={handleRetry}
          disabled={retryMutation.isPending}
          className="ml-2 flex items-center"
        >
          {retryMutation.isPending ? (
            <Spinner size="xs" className="mr-1 shrink-0" />
          ) : (
            <RefreshCw className="w-3 h-3 mr-1 shrink-0" />
          )}
          <span className="whitespace-nowrap">Redémarrer</span>
        </Button>
      )}
    </div>
  );
}
